import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TopicSummaryTable from '../TopicSummaryTable';
import CodeSnippet from '../shared/CodeSnippet';
import * as actions from '../../redux/actions';
import { getTopic } from '../../redux/reducers';

class TopicSummary extends Component {
	state = {
		showKey: false
	};

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (this.props.id !== prevProps.id) {
			this.fetchData();
		}
	}

	fetchData() {
		const { fetchTopic, fetchTopicBalance, fetchTopicRecentTransactionsCount, id } = this.props;
		// fetchTopicBalance(id);
		// fetchTopicRecentTransactionsCount(id);
		// fetchTopic(id);
	}

	onShowKey = () => {
		this.setState({ showKey: true });
	};

	onHideKey = () => {
		this.setState({ showKey: false });
	};

	render() {
		const { topic } = this.props;
		console.log("TOPIC IN TOPIC SUMMARY: ", topic)
		const { showKey } = this.state;
		return (
			<React.Fragment>
				<TopicSummaryTable topic={topic} onShowKey={this.onShowKey} />
				{/* {topic &&
				showKey && <CodeSnippet code={topic.adminKey} onClose={this.onHideKey} title="Public Key(s)" />} */}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, { match: { params: { topicID } } }) => ({
	id: topicID,
	// topic: getTopic(state, topicID)
});

TopicSummary = withRouter(connect(mapStateToProps, actions)(TopicSummary));

export default TopicSummary;
